<mat-toolbar color="primary" class="footer bg-primary">
  <mat-toolbar-row>
    <div class="col-12 footer-text center-block">
      <ul class="list-group list-group-horizontal mb-0 text-uppercase d-flex justify-content-between">
        <li class=""> &copy; {{current_year}} Copyright Global Widget </li>
      </ul>
    </div>
  </mat-toolbar-row>
</mat-toolbar>
